import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { ProjectStateAsString, ProjectStatus } from 'controllers/Project/ProjectStateMachine'
import { useDefiningStateItem } from './useDefiningStateItem'
import { useProjectStateItem } from './useProjectStateItem'

export const DefiningState = () => {
  const {
    getStateTranslationKey,
    stateItemIsCurrentOrPast,
    classes,
    changeStatus,
    SavingComponent,
    LightTooltip
  } = useProjectStateItem(ProjectStatus.DEFINING)

  const { canChangeToDefiningState, Errors, errorStyle } = useDefiningStateItem()

  const handleClick = () => {
    if (canChangeToDefiningState) {
      changeStatus(ProjectStateAsString.DEFINING)
    }
  }

  return (
    <LightTooltip
      title={canChangeToDefiningState ? '' : <Errors />}
      interactive
    >
      <li style={!canChangeToDefiningState ? errorStyle : null} className={stateItemIsCurrentOrPast() ? classes.active : classes.disabled} onClick={handleClick}>
        <LocalizedTypography
          translationKey={getStateTranslationKey()}
          variant="body2"
        />
        {/* <ErrorCountBadge errorCount={errorCount} /> */}
        <SavingComponent />
      </li>
    </LightTooltip>
  )
}
